import * as React from "react";
import "../styles.scss";
import {IInsuranceInputField} from "StateInterface";
import {addCommas} from "insurance/utils";
import {dateFormat} from "userform/utils";
export const getSubmitButton = (submitText: string, handleSubmit: () => void, isAllowed?: boolean) => {
    return (
      <div>
          <button
          disabled={!isAllowed}
          className={isAllowed ? "insurance-submit-btn" : "insurance-submit-btn-disabled"}
          onClick={handleSubmit}
          >{submitText}</button>
      </div>
    );
};

export const getInsuranceDetails = (insuranceDetails) => {
    return (
        <div>
            <h5 className="main-heading p-0 m-0">{insuranceDetails.productTitle}</h5>
            <p>{insuranceDetails.productDescription}</p>
            <div className="row mt-2">
                <div className="col-sm-12 pt-2">
                    <div className="float-left">
                        <div><span className="color-lightgray">Coverage:</span> <b><i className="fa fa-inr text-dark price" aria-hidden="true"/> {addCommas(insuranceDetails.sumInsured)}</b></div>
                        <div><span className="color-lightgray">Validity:</span> <b>{insuranceDetails.validityInMonths}</b> Months</div>
                        <div><span className="color-lightgray">Package Cost: </span>
                            <b>{insuranceDetails.productPrice > 0 ? <span><i className="fa fa-inr text-dark price" aria-hidden="true"/> {insuranceDetails.productPrice} + GST</span> : "Free"}</b>
                        </div>
                    </div>
                    {insuranceDetails.distributor.displayImage &&
                    <div className="float-right">
                        <p className="p-0 m-0 insured-text">Insured by</p>
                        <img className="insured-logo" src={insuranceDetails.distributor.displayImage}/>
                    </div>
                    }
                </div>
            </div>
        </div>
    );
};

export function getRegexFromString(regex) {
    const firstIndex = regex.indexOf("/");
    const lastIndex = regex.lastIndexOf("/");
    return regex.substring(firstIndex + 1, lastIndex);
}

export function getFieldsForInsurance(field: IInsuranceInputField[], userInfo: any) {
    const details = field.map((inputDetails) => {
        const fieldName = inputDetails.label.replace(/ /g, "").toLowerCase();
        const type = inputDetails.type.toLowerCase();
        return{
            inputType: type,
            label: inputDetails.label,
            name: fieldName,
            value: userInfo && userInfo.hasOwnProperty(fieldName) ?
            getValuesForInputFields(userInfo[fieldName], type) :
            inputDetails["value"] && inputDetails["value"] !== 0 ? getValuesForInputFields(inputDetails.value, type, inputDetails.label) : "",
            options: inputDetails.hasOwnProperty("options") ? inputDetails.options : null,
            regex: inputDetails.hasOwnProperty("regex") ? inputDetails.regex : null,
            min: inputDetails.hasOwnProperty("min") ? inputDetails.min : null,
            max: inputDetails.hasOwnProperty("max") ? inputDetails.max : null,
            max_length: inputDetails.hasOwnProperty("max_length") ? inputDetails.max_length : null,
        };
    });
    return details;
}
export function getValueForInsuranceField(value, type: string) {
    if (type === "date") {
        return value === "" ? null : new Date(String(value)).getTime();
    }
    return value;
}
export function getValuesForInputFields(value, type: string, label?: string) {
    if (type === "date") {
        return value === "" ? null : dateFormat(value);
    }
    else if (type === 'radio' && value && label && label === "Gender") {
        return `${value[0].toUpperCase()}${value.slice(1)}`;
    }
    return value;
}
export function productPriceCalculation(productPrice: number) {
    const totalAmount = Math.round(productPrice * Number(1.18));
    const gst = Math.round(totalAmount - productPrice);
    return(
        <div className="p-1 border mx-2">
            <table className="table table-borderless table-sm">
                <tbody>
                <tr>
                    <td className="px-2">Policy Premium</td>
                    <td>Rs. {productPrice}</td>
                </tr>
                <tr>
                    <td className="px-2">GST (@18%)</td>
                    <td>Rs. {gst}</td>
                </tr>
                <tr className="table-active">
                    <td className="px-2">Total Payable Amount</td>
                    <td>Rs. {totalAmount}</td>
                </tr>
                </tbody>
            </table>
        </div>
    );
}
export function profileStyle() {
    return {
        handleContainerStyle: (hasError) => {
            return {
                padding: ".5rem",
                margin: "3px",
                fontSize: "14px",
                color: "rgb(87, 87, 87)",
                fontWeight: "600",
            };
        },
        headerStyle: {
            color: "rgb(87, 87, 87)",
            fontSize: "20px",
            padding: "15px 0px 10px 10px",
            marginBottom: ".5rem",
        },
        submitButtonStyle: {
            backgroundColor: "#F5821F",
            cursor: "pointer",
            color: "#FFFFFF",
            border: "none",
            padding: "10px",
            width: "96%",
            margin: "4% 2%",
            borderRadius: "25px",
        },
        inputStyle: {
            handleTextFieldStyle: (hasError) => {
                return {
                    color: "#495057",
                    border: "none",
                    borderBottom: `1px solid ${hasError ? "red" : "lightgray"}`,
                    padding: ".375rem .75rem",
                    width: "100%",
                };
            },
            handleDropdownStyle: (hasError) => {
                return {
                    color: "#495057",
                    border: "none",
                    background: "transparent",
                    borderBottom: `1px solid ${hasError ? "red" : "lightgray"}`,
                    padding: ".375rem .75rem",
                    width: "100%",
                };
            },
            handleRadioStyle: (hasError) => {
                return {
                    background: "#fff",
                    border: "1px solid #e6e7e8",
                    minWidth: "80px",
                    color: "#a5a5a5",
                    padding: "5px",
                    margin: "0.5%",
                    display: "inline-block",
                    width: "49%",
                    onSelect: {
                        background: "#F5821F",
                        border: "1px solid #F5821F",
                        color: "#fff",
                    },
                };
            },
            handleUploadDocStyle: (hasError) => {
                return {
                    borderRadius: "3px",
                    color: "#495057",
                    backgroundColor: "#f9f9f9",
                    border: `1px solid ${hasError ? "red" : "#e8eaec"}`,
                    padding: ".375rem .75rem",
                    width: "100%",

                };
            },
            handleDateStyle: (hasError) => {
                return {
                    color: "#495057",
                    border: "none",
                    background: "transparent",
                    borderBottom: `1px solid ${hasError ? "red" : "lightgray"}`,
                    padding: ".375rem .75rem",
                    width: "100%",

                };
            },
        },
        handleErrorStyle: (hasError) => {
            return {
                color: "red",
                font: "12px",
            };
        },
    };
}